document.addEventListener("DOMContentLoaded",function(){
  if ($('#CollectionProductsContainer').length){
    const plpObserver = new MutationObserver( () =>{
      console.log('PLP Observer Triggered');
      $('#vehicle-trigger-plp').on('click', function (e, years) {
        e.preventDefault();
        $('body').addClass('NewsletterActive').addClass('scrollHidden');
        $('.fitment-finder-popup').addClass('active').trigger('focus');
        focusElement = window;
        var form = $(this).parent().find('form');
        window.focus();
        focusElement = '';
      });
    });

    plpObserver.observe(document.getElementById('CollectionProductsContainer'), { childList: true });
  }

  if (!JSON.parse(localStorage.getItem('fitment:filled')) || 
      !localStorage.getItem('fitment:year') || 
      !localStorage.getItem('fitment:make') || 
      !localStorage.getItem('fitment:model') ||
      !localStorage.getItem('fitment:body')) {
    localStorage.setItem('fitment:filled', false);
    localStorage.removeItem('fitment:year');
    localStorage.removeItem('fitment:make');
    localStorage.removeItem('fitment:model');
    localStorage.removeItem('fitment:body');
    localStorage.removeItem('fitment:vehiclequalifier');
    localStorage.removeItem('fitment:model:ID');
    localStorage.removeItem('fitment:install');
  } else {
    $('#SubmitBtn').click();
  }

  // Load years in the background so they are popd when modal is opened;
  let data = {
    TableName: 'vehicle-catalog',
    step: 'year'
  };

  initData(data, $('#year'));

  // Handle open model event
  $('#vehicle-trigger, #vehicle-trigger-plp, #vehicle-trigger-pdp').on('click', function (e, years) {
    e.preventDefault();
    $('body').addClass('NewsletterActive').addClass('scrollHidden');
    $('.fitment-finder-popup').addClass('active').trigger('focus');
    focusElement = window;
    var form = $(this).parent().find('form');
    window.focus();
    focusElement = '';
  });

  // Handle close modal event
  $('.pop_cross').on('click', function (e) {
    e.preventDefault();
    $('.fitment-finder-popup').removeClass('active');
    $('body').removeClass('NewsletterActive').removeClass('scrollHidden');

    if (JSON.parse(localStorage.getItem('fitment:filled'))){
      $('#SubmitBtn').click();
    }

    window.focus();
    focusElement = '';
  });
  
  // Handle form change events
  $('#fitment-form-popup select').on("change", function(e){
    switch (this.id) {
      case 'year':
        localStorage.setItem('fitment:year', this.value);
        data = {
          TableName: 'vehicle-catalog',
          step: 'make',
          year: $('#year').val()
        }
        selector = $('#make');
        break;
      case 'make':
        localStorage.setItem('fitment:make', this.value);
        data = {
          TableName: 'vehicle-catalog',
          step: 'model',
          year: $('#year').val(),
          make: $('#make').val()
        };
        selector = $('#model');
        break;
      case 'model':
        localStorage.setItem('fitment:model', this.value);
        data = {
          TableName: 'vehicle-catalog',
          step: 'body',
          year: $('#year').val(),
          make: $('#make').val(),
          model: $('#model').val()
        };
        selector = $('#body');
        break;
      case 'body':
        // reset vehicle qualifier
        $('#vehiclequalifier').children('option:not(:first-child)').remove();
        $('#vehiclequalifier').attr('disabled', true);
        $('#vehiclequalifier-warning').addClass('titan-hide');
        localStorage.removeItem('fitment:vehiclequalifier');
        localStorage.removeItem('fitment:model:ID');
        localStorage.removeItem('fitment:install');

        if ($(this).find(':selected').data('install-number')) {
          $(`#vehiclequalifier-container`).addClass('titan-hide');
          localStorage.setItem('fitment:body', this.value);
          localStorage.setItem('fitment:install', $(this).find(':selected').data('install-number'));
          localStorage.setItem('fitment:model:ID', $(this).find(':selected').data('id'));
          $('#SubmitBtn').removeAttr('disabled');
          return;
        } else {
          localStorage.setItem('fitment:body', this.value);
          $(`#vehiclequalifier-container`).removeClass('titan-hide');
          $('#vehiclequalifier').removeAttr('disabled');
          data = {
            TableName: 'vehicle-catalog',
            step: 'vehiclequalifier',
            year: $('#year').val(),
            make: $('#make').val(),
            model: $('#model').val(),
            body: $('#body').val()
          };
          selector = $('#vehiclequalifier');
          break;
        }
      case 'vehiclequalifier': 
        localStorage.setItem('fitment:vehiclequalifier', this.value);
        if (this.value === 'unknown') {
          localStorage.setItem('fitment:install', 'none')
          $(`#vehiclequalifier-warning`).removeClass('titan-hide');
        } else {
          localStorage.setItem('fitment:install', $(this).find(':selected').data('install-number'));
          localStorage.setItem('fitment:model:ID', $(this).find(':selected').data('id'));
          $(`#vehiclequalifier-warning`).addClass('titan-hide');
        }
        $('#SubmitBtn').removeAttr('disabled');
        return;
      default:
        break;
    }

    if (this.selectedIndex != 0) {
      nextSelect = $(this).nextAll('select')[0];
      $(nextSelect).children('option:not(:first-child)').remove();
      initData(data, selector);
      $(nextSelect).removeAttr('disabled');
    } else {
      $(this).nextAll('select').attr("disabled", true);
      $(this).nextAll('select').val(null);
      $(this).nextAll('select').children('option:not(:selected)').remove();
      $('#SubmitBtn').attr('disabled', true);
    }
  });

});

function initData(data, selector) {
  console.debug('[Fitment Finder - initData] Called with data:', JSON.stringify(data), 'for selector:', selector[0].id);
  const baseUrl = retrieveAPIUrl();
  localStorage.setItem('apiUrl', baseUrl);

  $.ajax({
    url: baseUrl,            
    method: 'GET',
    crossDomain: true,
    type: 'json',
    data: data,
    beforeSend: function() {
      console.debug('[Fitment Finder - initData] Sending request to:', this.url, 'with data:', JSON.stringify(data));
    },
    success: function (data) {
      console.debug('[Fitment Finder - initData] AJAX success for', selector[0].id, 'received data:', JSON.stringify(data));
      if (selector[0].id == 'year') {
        data.sort().reverse();
      } else if (this.url.includes('step=model')){
        data.sort((a, b) => a.model - b.model);
      } else {
        data.sort();
      }
      console.debug('[Fitment Finder - initData] After sorting data:', JSON.stringify(data));
      data.map(setValues, selector);
      console.debug('[Fitment Finder - initData] After mapping values, selector has', $(selector).children().length, 'options');
    },
    error: function (error) {
      console.error('[Fitment Finder - initData] AJAX error for', selector[0].id, 'with error:', error);
      console.error('[Fitment Finder - initData] Error:', JSON.stringify(error));
    }
  });
}

function setValues(value){
  console.debug('[Fitment Finder - setValues] Called for:', this[0].id, 'with value:', JSON.stringify(value));
  if (this[0].id == 'body'){
      const existingOption = document.querySelectorAll(`option[value='${value.body}']`);
      if (existingOption.length === 0) {
        if (value.vehiclequalifier.length === 0) {
          $(this).append('<option value="' + value.body + '" data-install-number="'+ value.installnumber + '" data-id="'+ value.vehicleId + '">' + value.body +'</option>');
          console.debug('[Fitment Finder - setValues] Appended body option with install number:', value.body);
        } else {
          $(this).append('<option value="' + value.body + '">' + value.body +'</option>');
          console.debug('[Fitment Finder - setValues] Appended body option without install number:', value.body);
        }
      }
    } else if (this[0].id == 'vehiclequalifier') {
      const existingOption = document.querySelectorAll(`option[value='${value.vehiclequalifier}']`);
      if (existingOption.length === 0) {
        $(this).append('<option value="' + value.vehiclequalifier + '" data-install-number="'+ value.installnumber + '" data-id="'+ value.vehicleId + '">' + value.vehiclequalifier +'</option>');
        console.debug('[Fitment Finder - setValues] Appended vehicle qualifier option with install number:', value.vehiclequalifier);
      }
    } else {
      const existingOption = document.querySelectorAll(`option[value='${value}']`);
      if (existingOption.length === 0) {
        $(this).append('<option value="' + value + '">' + value +'</option>');
      }
      console.debug('[Fitment Finder - setValues] Appended option:', value, 'to selector:', this[0].id);
  }
}

function retrieveAPIUrl() {
  const currentUrl = window.location.href;
  let apiUrl

  if (currentUrl.includes('https://usa.pioneer/')) {
    apiUrl =  "https://aduq57kdnj.execute-api.us-east-1.amazonaws.com/default/fetchVehicleOptions";
  } else {
    apiUrl = "https://aduq57kdnj.execute-api.us-east-1.amazonaws.com/default/fetchVehicleOptions-dev";
  }

  console.debug('[Fitment Finder - retrieveAPIUrl] Retrieved API URL:', apiUrl);
  return apiUrl;
}
